import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import HowPowerFarmWorks from "@/components/home/HowPowerFarmWorks";
import RealEstateAnalogy from "@/components/home/RealEstateAnalogy";
import VsListedStocks from "@/components/home/VsListedStocks";
import MoneyBreakdown from "@/components/home/MoneyBreakdown";
import HowAIWorks from "@/components/home/HowAIWorks";

const COPY = {
  en: { heroEy: "Explainer", heroT: "How Titan Infra works.", heroL: "Land, modular data centers and compute-as-a-service. Explained without jargon.", cta: "I want to participate" },
  fr: { heroEy: "Explication", heroT: "Comment fonctionne Titan Infra.", heroL: "Terrain, data centers modulaires et calcul-en-tant-que-service. Expliqué sans jargon.", cta: "Je veux participer" },
  es: { heroEy: "Explicación", heroT: "Cómo funciona Titan Infra.", heroL: "Suelo, data centers modulares y cálculo como servicio. Explicado sin jerga.", cta: "Quiero participar" },
};

export default function HowItWorks() {
  const { lang } = useI18n();
  const c = COPY[lang] || COPY.en;
  return (
    <>
      <PageHero eyebrow={c.heroEy} title={c.heroT} lead={c.heroL} />
      <HowPowerFarmWorks />
      <RealEstateAnalogy />
      <HowAIWorks />
      <VsListedStocks />
      <MoneyBreakdown />
      <div className="bg-black text-white text-center py-24 md:py-32 px-6">
        <Link to="/invest" data-testid="how-page-cta"
          className="inline-flex items-center gap-2 rounded-full h-12 md:h-14 px-8 bg-gradient-to-r from-emerald-500 to-sky-500 hover:from-emerald-400 hover:to-sky-400 text-white text-[13px] tracking-wide">
          {c.cta} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </>
  );
}

export const PageHero = ({ eyebrow, title, lead }) => (
  <section className="bg-zinc-950 text-white pt-32 md:pt-40 pb-16 md:pb-24">
    <div className="max-w-[1440px] mx-auto px-6 md:px-10">
      <p className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-medium text-emerald-400">
        <span className="w-6 h-px bg-emerald-400" /> {eyebrow}
      </p>
      <h1 className="mt-4 font-display font-light tracking-tighter text-5xl md:text-7xl leading-[1.02] max-w-4xl">{title}</h1>
      {lead && <p className="mt-6 text-[17px] md:text-[19px] leading-relaxed text-white/60 max-w-2xl">{lead}</p>}
    </div>
  </section>
);
